import { Controller } from '@hotwired/stimulus';
import { showModal, hideModal } from '../utils/modal';
import Cookies from 'js-cookie';

export default class extends Controller {
  initialize() {
    if (!Cookies.get('create-budget')) {
      showModal('create-budget', { disableFocus: true });
      this.hasSeenModal();
    }
  }

  close() {
    event.cancelBubble = true;
    hideModal('create-budget');
  }

  hasSeenModal() {
    Cookies.set('create-budget', Date.now(), { expires: 7 });
  }
}
